/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import EmergencyDetails from "./EmergencyDetails";
import RiskAssessmentAndControls from "./RiskAssessmentAndControls";
import Signatures from "./Signatures";
import ConfirmSiteSafety from "./ConfirmSiteSafety";
import SelectTeamData from "./SelectTeamData";
import SelectDropDowns from "./SelectDropDowns";
import { convertDateToEpochUTC } from "../../../../helper/DateConverters";
import { dataURLToFile, getTodayDate } from "../helper/helperFunctions";
import axios from "../../../../util/axiosconfig";
import { showError, showSuccess } from "../../../../util/ShowStatus";
import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { SignaturePadRef } from "./SignaturePadComponent";
import { InputText } from "primereact/inputtext";

const AddLeakDetection = () => {
  const toast = useRef<Toast>(null);
  const [riskAssessmentDataSubmitting, setRiskAssessmentDataSubmitting] =
    useState<boolean>(false);
  const [isUploadInProgress, setIsUploadInProgress] = useState<boolean>(false);

  const [selectedAandE, setSelectedAandE] = useState<any>(null);
  const [selectedEmergencyContact, setSelectedEmergencyContact] =
    useState<any>(null);

  const [selectedTeam, setSelectedTeam] = useState<any>(null);
  const [selectedTeamMember1, setSelectedTeamMember1] = useState<any>(null);
  const [selectedTeamMember2, setSelectedTeamMember2] = useState<any>(null);
  const [additionalTeamMember, setAdditionalTeamMember] = useState<any>([]);
  const [images1, setImages1] = useState<any>({});
  const [images2, setImages2] = useState<any>({});
  const [images3, setImages3] = useState<any>({});

  const firstRef = useRef<SignaturePadRef | null>(null);
  const secondRef = useRef<SignaturePadRef | null>(null);
  const [additionalMemberRefs, setAdditionalMemberRefs] = useState<
    React.RefObject<SignaturePadRef>[]
  >([]);

  const [fileValues, setFileValues] = useState<any>({
    photo: [],
  });

  const [formErrors, setFormErrors] = useState<any>({
    workArea: null,
    teamMember1: null,
    teamMember1Photo: null,
    teamMember2: null,
    teamMember2Photo: null,
    additionalTeamMembers: [],
    dma_location: null,
    vehicleRegistration: null,
    keyPlantDetails: null,
    activity: null,
    emergencyDetails: {
      aAndE: null,
      emergencyContact: null,
      isFirstAiderAvailable: null,
      isFirstAidKitAvailable: null,
    },
    startWorkAssessment: {
      checklist: {
        handlingEquipment: null,
        drivingAssessment: null,
        highwayCodeTest: null,
        vehicleSafetyTest: null,
        issueOfPPE: null,
      },
      riskelements: {
        loneWorking: null,
        pedestrianPublicEgress: null,
        coshhMaterials: null,
        nightWorking: null,
        environmental: null,
        toolAndEquipment: null,
        underfootHazards: null,
        trafficManagement: null,
      },
    },
    confirmSiteSafety: null,
    signatures: {
      teamMember1: null,
      teamMember2: null,
      additionalTeamMembers: [],
    },
  });

  const [timeStampLocationValues, setTimeStampLocationValues] = useState<any>({
    locations: [],
    timeStamps: [],
  });

  const [formValues, setFormValues] = useState<any>({
    date: convertDateToEpochUTC(new Date(new Date().setHours(0, 0, 0, 0))),
    teamName: null,
    teamID: null,
    teamMember1: {
      userID: null,
      displayName: null,
      photo: null,
      signature: null,
      signatureDate: null,
    },
    teamMember2: {
      userID: null,
      displayName: null,
      photo: null,
      signature: null,
      signatureDate: null,
    },
    additionalTeamMembers: [],
    dma_location: null,
    vehicleRegistration: null,
    keyPlantDetails: null,
    activity: null,
    emergencyDetails: {
      aAndE: null,
      emergencyContact: null,
      isFirstAiderAvailable: null,
      isFirstAidKitAvailable: null,
    },
    startWorkAssessment: {
      checklist: [
        {
          label:
            "Have all team members read, understood and agreed on the risk assessment and method statement.    ",
          value: null,
          name: "handlingEquipment",
        },
        {
          label: "Have all team membersreceived an induction?",
          value: null,
          name: "drivingAssessment",
        },
        {
          label: "Is there at least one trained NRSWA Operative on site?",
          value: null,
          name: "highwayCodeTest",
        },
        {
          label:
            "Are team members trained, have an in-date ticket and competent?",
          value: null,
          name: "vehicleSafetyTest",
        },
        {
          label:
            "Does the team have PPE as defined within Risk Assessments & Method Statements?",
          value: null,
          name: "issueOfPPE",
        },
      ],
      riskelements: [
        { label: "Lone Working ", value: null, name: "loneWorking" },
        {
          label: "Pedestrians/Public Access/Egress",
          value: null,
          name: "pedestrianPublicEgress",
        },
        {
          label: "COSHH Materials (i.e. chlorus, cement) ",
          value: null,
          name: "coshhMaterials",
        },
        { label: "Night Working", value: null, name: "nightWorking" },
        {
          label: "Environmental (i.e. dust, waste, spillage)",
          value: null,
          name: "environmental",
        },
        { label: "Tool & Equipment ", value: null, name: "toolAndEquipment" },
        {
          label: "Underfoot Hazards(i.e. wet,sloping ground, footpath boards)",
          value: null,
          name: "underfootHazards",
        },
        {
          label: "Traffic Management",
          value: null,
          name: "trafficManagement",
        },
      ],
    },
    additionalComments: null,
    confirmSiteSafety: {
      label:
        "Please Confirm That the site & key plant is safe, and works can proceed safely. ",
      value: null,
      name: "confirmSafety",
      areaManager: null,
    },
  });

  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // Function to clear all signatures
  const clearAllSignatures = useCallback(() => {
    // Don't clear signatures on initial load
    if (isInitialLoad) return;

    // Clear client signature
    if (firstRef.current) {
      firstRef.current.clear();
    }

    if (secondRef.current) {
      secondRef.current.clear();
    }

    // Clear all staff member signatures
    additionalMemberRefs.forEach((ref) => {
      if (ref.current) {
        ref.current.clear();
      }
    });
  }, [
    formValues?.teamMember1,
    formValues?.teamMember2,
    formValues?.additionalTeamMembers,
    isInitialLoad,
  ]);

  // Clear signatures when form values change
  useEffect(() => {
    clearAllSignatures();
  }, [
    formValues?.teamName,
    formValues?.teamID,
    formValues?.teamMember1?.userID,
    formValues?.teamMember2?.userID,
    formValues?.additionalTeamMembers,
    formValues?.dma_location,
    formValues?.vehicleRegistration,
    formValues?.keyPlantDetails,
    formValues?.activity,
    formValues?.emergencyDetails?.aAndE,
    formValues?.emergencyDetails?.emergencyContact,
    formValues?.emergencyDetails?.isFirstAiderAvailable,
    formValues?.emergencyDetails?.isFirstAidKitAvailable,
    formValues?.startWorkAssessment?.checklist,
    formValues?.startWorkAssessment?.riskelements,
    formValues?.additionalComments,
    formValues?.confirmSiteSafety?.value,
    clearAllSignatures,
  ]);

  // Clear signatures when photos change
  useEffect(() => {
    clearAllSignatures();
  }, [fileValues, clearAllSignatures]);

  // Update refs when additionalTeamMembers changes
  useEffect(() => {
    setAdditionalMemberRefs((prevRefs) => {
      // Keep existing refs
      const newRefs = [...prevRefs];
      // Add new refs if needed
      while (newRefs.length < formValues.additionalTeamMembers.length) {
        newRefs.push(React.createRef<any>());
      }
      // Remove extra refs if needed
      while (newRefs.length > formValues.additionalTeamMembers.length) {
        newRefs.pop();
      }
      return newRefs;
    });
  }, [formValues.additionalTeamMembers.length]);

  // // Clear signatures when form values change
  // useEffect(() => {
  //   clearAllSignatures();
  // }, [
  //   formValues?.teamName,
  //   formValues?.teamID,
  //   formValues?.teamMember1?.userID,
  //   formValues?.teamMember2?.userID,
  //   formValues?.additionalTeamMembers,
  //   formValues?.dma_location,
  //   formValues?.vehicleRegistration,
  //   formValues?.keyPlantDetails,
  //   formValues?.activity,
  //   formValues?.emergencyDetails?.aAndE,
  //   formValues?.emergencyDetails?.emergencyContact,
  //   formValues?.emergencyDetails?.isFirstAiderAvailable,
  //   formValues?.emergencyDetails?.isFirstAidKitAvailable,
  //   // formValues?.startWorkAssessment,
  //   formValues?.startWorkAssessment?.checklist,
  //   formValues?.startWorkAssessment?.riskelements,
  //   formValues?.additionalComments,
  //   formValues?.confirmSiteSafety?.value,
  //   clearAllSignatures,
  // ]);

  const [confirmmessage, setConfirmmessage] = useState([
    {
      label:
        "Do you confirm works area, plant and equipment are safe, and works can proceed safely.",
      status: "null",
      name: "confirmSafety",
    },
  ]);

  const onStatusChangeConfirm = (e: any, index: number) => {
    const { value } = e.target;
    const updatedconfirmmessage = [...confirmmessage];
    updatedconfirmmessage[index].status = value;
    setConfirmmessage(updatedconfirmmessage);
  };

  const navigate = useNavigate();

  const validateForm = (): boolean => {
    const errors: Partial<Record<string, string>> = {};
    // Check required fields
    if (!formValues.date) {
      showError("Date is required", toast);
      return false;
    }
    if (!formValues.teamName || !formValues.teamID) {
      showError("Work Area is required", toast);
      return false;
    }
    if (!formValues.teamMember1.userID) {
      showError("Team Member 1 is required", toast);
      return false;
    }
    if (
      !fileValues.find((photo: any) => {
        return photo.userID === formValues.teamMember1.userID;
      })
    ) {
      showError("Photo of Team Member 1 is required", toast);
      return false;
    }
    // if (!formValues.teamMember2.userID) {
    //   showError("Team Member 2 is required", toast);
    //   return false;
    // }
    if (
      formValues?.teamMember2.userID &&
      !fileValues.find((photo: any) => {
        return photo.userID === formValues.teamMember2.userID;
      })
    ) {
      showError("Photo of Team Member 2 is required", toast);
      return false;
    }
    if (formValues.additionalTeamMembers.length > 0) {
      for (let i = 0; i < formValues.additionalTeamMembers.length; i++) {
        const member = formValues.additionalTeamMembers[i];
        const photoExists = fileValues.some(
          (photo: any) => photo.userID === member.userID
        );
        if (!photoExists) {
          showError(
            `Photo of Additional Team Member ${member.displayName} is required`,
            toast
          );
          return false;
        }
      }
    }
    if (!formValues.dma_location) {
      showError("DMA/Location is required", toast);
      return false;
    }
    if (!formValues.vehicleRegistration) {
      showError("Vehicle Registration is required", toast);
      return false;
    }
    if (!formValues.keyPlantDetails) {
      showError("Key Plant Details are required", toast);
      return false;
    }
    if (!formValues.activity) {
      showError("Activity is required", toast);
      return false;
    }
    if (formValues.emergencyDetails.isFirstAiderAvailable === null) {
      showError("First Aider availability is required", toast);
      return false;
    }
    if (formValues.emergencyDetails.isFirstAidKitAvailable === null) {
      showError("First Aid Kit availability is required", toast);
      return false;
    }
    if (!formValues.emergencyDetails.aAndE) {
      showError("Closest A&E detail is required", toast);
      return false;
    }
    if (!formValues.emergencyDetails.emergencyContact) {
      showError("Emergency Contact is required", toast);
      return false;
    }
    // if (hasEmptyActions) {
    //   showError("Actions are required for all selected risk elements", toast);
    //   return false;
    // }
    // Check checklist values
    const hasInvalidChecklist = formValues.startWorkAssessment.checklist.some(
      (item: any) => item.value === null
    );
    if (hasInvalidChecklist) {
      showError("All checklist items must have a value", toast);
      return false;
    }

    // Check risk elements values
    const hasInvalidRiskElements =
      formValues.startWorkAssessment.riskelements.some(
        (element: any) => element.value === null
      );
    if (hasInvalidRiskElements) {
      showError("All risk elements must have a value", toast);
      return false;
    }

    // Check all risk elements have actions
    const hasEmptyActions = formValues.startWorkAssessment.riskelements.some(
      (element: any) => element.value === true && !element.action
    );
    if (hasEmptyActions) {
      showError("Actions are required for all risk elements", toast);
      return false;
    }

    // const hasEmptyActions = formValues.startWorkAssessment.riskelements.some(
    //   (element: any) => {
    //     return element.action === null || element.action === undefined;
    //   }
    // );

    // Check confirm site safety value
    if (formValues.confirmSiteSafety.value === null) {
      showError("Confirmation of site safety is required", toast);
      return false;
    }

    // Check signatures
    if (firstRef.current?.isEmpty()) {
      showError("Signature of Team Member 1 is required", toast);
      return false;
    }
    if (formValues?.teamMember2.userID && secondRef.current?.isEmpty()) {
      showError("Signature of Team Member 2 is required", toast);
      return false;
    }
    if (formValues.additionalTeamMembers.length > 0) {
      const hasEmptyAdditionalSignatures =
        formValues.additionalTeamMembers.some((member: any, index: number) => {
          const ref = additionalMemberRefs[index];
          return ref.current?.isEmpty();
        });
      if (hasEmptyAdditionalSignatures) {
        showError(
          "Signatures for all Additional Team Members are required",
          toast
        );
        return false;
      }
    }

    return true;
  };

  const handleSave = async () => {
    try {
      if (!validateForm()) {
        return;
      }
      setRiskAssessmentDataSubmitting(true);
      // Prepare FormData
      const formData = new FormData();

      // 1. Process signatures
      const signatures: File[] = [];
      const photosArray: File[] = [];

      // Process teamMember1 signature
      if (
        firstRef.current &&
        !firstRef.current.isEmpty() &&
        formValues.teamMember1.userID
      ) {
        const signatureDataUrl = firstRef.current.toDataURL();
        const signatureFile = dataURLToFile(
          signatureDataUrl,
          `${formValues.teamMember1.userID}_sig.png`
        );
        if (signatureFile) {
          signatures.push(signatureFile);
        }
      }
      // Process teamMember2 signature
      if (
        secondRef.current &&
        !secondRef.current.isEmpty() &&
        formValues.teamMember2.userID
      ) {
        const signatureDataUrl = secondRef.current.toDataURL();
        const signatureFile = dataURLToFile(
          signatureDataUrl,
          `${formValues.teamMember2.userID}_sig.png`
        );
        if (signatureFile) {
          signatures.push(signatureFile);
        }
      }
      // Process additional team members signatures
      formValues.additionalTeamMembers.forEach((member: any, index: number) => {
        const ref = additionalMemberRefs[index];
        if (ref.current && !ref.current.isEmpty() && member.userID) {
          const signatureDataUrl = ref.current.toDataURL();
          const signatureFile = dataURLToFile(
            signatureDataUrl,
            `${member.userID}_sig.png`
          );
          if (signatureFile) {
            signatures.push(signatureFile);
          }
        }
      });

      // Process photos from fileValues.photo
      fileValues.forEach((photoItem: any) => {
        if (photoItem.userID && photoItem.images?.default) {
          const fileName = `${photoItem.userID}_photo.png`;
          const dataURL = new Blob([photoItem.images.default], {
            type: "image/png",
          });
          // Convert Blob to File
          const photoFile = new File([dataURL], fileName, {
            type: "image/png",
          });
          photosArray.push(photoFile);

          // Update the photo reference in formValues
          if (formValues.teamMember1.userID === photoItem.userID) {
            formValues.teamMember1.photo = fileName;
          } else if (formValues.teamMember2.userID === photoItem.userID) {
            formValues.teamMember2.photo = fileName;
          } else {
            const additionalMember = formValues.additionalTeamMembers.find(
              (m: any) => m.userID === photoItem.userID
            );
            if (additionalMember) {
              additionalMember.photo = fileName;
            }
          }
        }
      });

      // Add all signatures to FormData
      signatures.forEach((file, index) => {
        formData.append(`signature`, file);
      });

      // 2. Process profile images
      const profileImages: File[] = [];

      // Process teamMember1 photo
      if (fileValues.photo) {
        const member1Photo = fileValues.photo.find(
          (photo: any) => photo.userID === formValues.teamMember1.userID
        );
        if (member1Photo?.images?.[0]) {
          const photoFile = dataURLToFile(
            member1Photo.images[0],
            `${formValues.teamMember1.userID}_photo.png`
          );
          if (photoFile) {
            profileImages.push(photoFile);
          }
        }
      }

      // Process teamMember2 photo
      if (fileValues.photo) {
        const member2Photo = fileValues.photo.find(
          (photo: any) => photo.userID === formValues.teamMember2.userID
        );
        if (member2Photo?.images?.[0]) {
          const photoFile = dataURLToFile(
            member2Photo.images[0],
            `${formValues.teamMember2.userID}_photo.png`
          );
          if (photoFile) {
            profileImages.push(photoFile);
          }
        }
      }

      // Process additional team members photos
      formValues.additionalTeamMembers.forEach((member: any) => {
        if (fileValues.photo) {
          const additionalMemberPhoto = fileValues.photo.find(
            (photo: any) => photo.userID === member.userID
          );
          if (additionalMemberPhoto?.images?.[0]) {
            const photoFile = dataURLToFile(
              additionalMemberPhoto.images[0],
              `${member.userID}_photo.png`
            );
            if (photoFile) {
              profileImages.push(photoFile);
            }
          }
        }
      });

      // Add all profile images to FormData
      photosArray.forEach((file, index) => {
        formData.append(`profileImages`, file);
      });

      formData.append("formJson", JSON.stringify(formValues));
      formData.append(
        "timeStampLocationJson",
        JSON.stringify(timeStampLocationValues)
      );
      formData.append("isWeb", "true");

      // 4. Make API call
      const response = await axios.post(
        "health-and-safety/leak-detection-form",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Handle success
      showSuccess(response.data.Message, toast);
      // resetForm(); // Clear the form after successful submission
      setRiskAssessmentDataSubmitting(false);
      navigate("/layout/leak-detection/team-listing");
    } catch (err) {
      const error = getErrorMessage(err);
      setRiskAssessmentDataSubmitting(false);
      showError(error, toast);
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="">
        {false ? (
          <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
            <ProgressSpinner />
          </div>
        ) : (
          <div className="tw-border-solid tw-border tw-border-[#E2E2e2] tw-rounded-lg  tw-relative tw-bg-white">
            {/* fix header  */}
            <div className="tw-bg-[#F8FAFC] tw-p-4 tw-rounded-t-lg tw-border-b-[1px] tw-border-[#E2E8F0] tw-flex tw-justify-between tw-items-center">
              <h2 className="xl:tw-text-2xl tw-text-xl tw-font-semibold tw-text-[#101828]">
                DAILY DYNAMIC RISK ASSESSMENT – LEAK DETECTION
              </h2>
            </div>
            <div>
              <div className="tw-p-4">
                {/* form 1 */}
                <div className="tw-p- tw-border-b-[1px] tw-border-[#E2E8F0]">
                  <h2 className="tw-text-lg tw-font-semibold tw-text-[#101828] tw-mb-2">
                    Basic Details
                  </h2>
                </div>
                <div className="tw-flex tw-flex-col tw-w-full md:tw-w-fit tw-mt-2">
                  <div className="tw-flex  tw-flex-col tw-gap-2  tw-items-start tw-justify-start  tw-my-2 ">
                    <label
                      className="leak-label tw-font-semibold tw-text-gray-800"
                      htmlFor="teamMember1"
                    >
                      Date
                    </label>
                    <InputText
                      type="text"
                      className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full lg:tw-w-[370px]"
                      value={getTodayDate() ?? ""}
                      readOnly
                    />
                  </div>
                  <SelectTeamData
                    toast={toast}
                    isUploadInProgress={isUploadInProgress}
                    setIsUploadInProgress={setIsUploadInProgress}
                    fileValues={fileValues}
                    setFileValues={setFileValues}
                    timeStampLocationValues={timeStampLocationValues}
                    setTimeStampLocationValues={setTimeStampLocationValues}
                    formValues={formValues}
                    setFormValues={setFormValues}
                    selectedTeam={selectedTeam}
                    setSelectedTeam={setSelectedTeam}
                    selectedTeamMember1={selectedTeamMember1}
                    setSelectedTeamMember1={setSelectedTeamMember1}
                    selectedTeamMember2={selectedTeamMember2}
                    setSelectedTeamMember2={setSelectedTeamMember2}
                    additionalTeamMember={additionalTeamMember}
                    setAdditionalTeamMember={setAdditionalTeamMember}
                    images1={images1}
                    setImages1={setImages1}
                    images2={images2}
                    setImages2={setImages2}
                    images3={images3}
                    setImages3={setImages3}
                  />
                  <SelectDropDowns
                    toast={toast}
                    isUploadInProgress={isUploadInProgress}
                    setIsUploadInProgress={setIsUploadInProgress}
                    formValues={formValues}
                    setFormValues={setFormValues}
                  />
                </div>

                {/* form 2 */}
                <div className="tw-p-4 tw-border-b-[1px] tw-border-[#E2E8F0]  ">
                  <h2 className="tw-text-lg tw-font-semibold tw-text-[#101828]">
                    Emergency Details
                  </h2>
                </div>
                <EmergencyDetails
                  toast={toast}
                  isUploadInProgress={isUploadInProgress}
                  setIsUploadInProgress={setIsUploadInProgress}
                  selectedAandE={selectedAandE}
                  setSelectedAandE={setSelectedAandE}
                  selectedEmergencyContact={selectedEmergencyContact}
                  setSelectedEmergencyContact={setSelectedEmergencyContact}
                  formValues={formValues}
                  setFormValues={setFormValues}
                />
                {/* form 3 */}
                <div className="tw-p-4 tw-border-b-[1px] tw-border-[#E2E8F0]  ">
                  <h2 className="tw-text-lg tw-font-semibold tw-text-[#101828]">
                    Risk Assessment and Controls
                  </h2>
                </div>
                <div>
                  <RiskAssessmentAndControls
                    toast={toast}
                    formValues={formValues}
                    setFormValues={setFormValues}
                    isUploadInProgress={isUploadInProgress}
                    setIsUploadInProgress={setIsUploadInProgress}
                    setIsInitialLoad={setIsInitialLoad}
                  />

                  <ConfirmSiteSafety
                    confirmmessage={confirmmessage}
                    isUploadInProgress={isUploadInProgress}
                    setIsUploadInProgress={setIsUploadInProgress}
                    onStatusChangeConfirm={onStatusChangeConfirm}
                    formValues={formValues}
                    setFormValues={setFormValues}
                  />

                  {formValues?.teamMember1?.userID && (
                    <Signatures
                      additionalTeamMembers={formValues.additionalTeamMembers}
                      formValues={formValues}
                      setFormValues={setFormValues}
                      firstRef={firstRef}
                      secondRef={secondRef}
                      additionalMemberRefs={additionalMemberRefs}
                    />
                  )}
                </div>
              </div>
              {/* footer content */}
              <div className="tw-flex tw-justify-end tw-items-center tw-p-4  tw-gap-2 !tw-border-t-[#E2E8F0] tw-border-t-[1px]">
                <Button
                  className="tw-flex tw-px-3 tw-py-2 tw-rounded focus:tw-shadow-none  !tw-border-[#C3E3F4] tw-text-[#344054] tw-font-medium"
                  label="Cancel"
                  onClick={() =>
                    navigate("/layout/leak-detection/team-listing")
                  }
                  color="white"
                />
                <Button
                  className="tw-flex tw-px-3 focus:tw-shadow-none tw-py-2 tw-rounded tw-bg-primary tw-border-primary tw-text-white tw-font-medium"
                  label={`${
                    riskAssessmentDataSubmitting ? "Saving..." : "Save"
                  }`}
                  disabled={riskAssessmentDataSubmitting}
                  loading={riskAssessmentDataSubmitting}
                  onClick={handleSave}
                />
              </div>
            </div>
          </div>
        )}
        {riskAssessmentDataSubmitting && (
          <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
            <ProgressSpinner />
          </div>
        )}
      </div>
    </>
  );
};

export default AddLeakDetection;
